// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"79b6e5a7","488":"3b9fb1d2","720":"832f8265","882":"a2340106","956":"2eae3b69","975":"f3863912"}[chunkId] + ".chunk.js";
};